
    <template>
    <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.6471 0.0498262L25.3695 0.0152588L25.3349 11.7377L11.6991 25.3735L0.0112305 13.6857L13.6471 0.0498262ZM22.1341 16.3357L23.6433 16.6014L21.9994 25.9396L14.5464 24.6265L14.8121 23.1128L20.7521 24.1604L22.1341 16.3357ZM16.3189 5.31831C15.2841 6.35316 15.2841 8.03098 16.3189 9.06583C17.3538 10.1007 19.0316 10.1007 20.0665 9.06583C21.1013 8.03098 21.1013 6.35316 20.0665 5.31831C19.0316 4.28346 17.3538 4.28346 16.3189 5.31831Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'QuantityDiscount',
    }) as DefineComponent
    </script>
    